export default "__VITE_ASSET__zN49qjxi__"